// import React, { Component } from "react"; # Unnecessary import since we are using functional component
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const Navbar = ({ setInterface, getInterface }) => {
  const pathLocation = useLocation().pathname;
  const [isHamburgerOpen, setIsHamburgerOpen] = useState(false);

  return (
    <div
      className={`w-full sticky top-0 shadow-md flex justify-center items-center p-0 z-50 ${
        getInterface() ? "bg-white" : "bg-gray-800"
      }`}
    >
      <header class={`header lg:w-7/12 w-full px-2 py-2`}>
        <div class={`flex items-center justify-between`}>
          {/* Logo */}
          <div class="w-1/12 md:w-3/12">
            <Link to="/" className="flex items-center justify-between">
              <img
                src={`${process.env.PUBLIC_URL}/images/icon/logo.png`}
                alt="Logo "
                className="w-10 md:w-12 transition duration-500 ease-in-out transform hover:scale-110 rounded-full"
              ></img>
              <p
                className={`hidden md:block duration-500 font-semibold text-md`}
              >
                Nikola Arinanda
              </p>
            </Link>
          </div>

          {/* Desktop Menu */}
          <div class="font-semibold text-md">
            {/* Desktop Menu */}
            <nav class="nav hidden md:flex justify-end">
              <div
                className={`p-2 lg:-4 border-b-2 border-black border-opacity-0 hover:border-opacity-100 hover:text-black duration-200 cursor-pointer active ${
                  pathLocation === "/about"
                    ? "text-gray-600"
                    : getInterface()
                      ? "text-black"
                      : "text-gray-300"
                }`}
              >
                <Link to="/about">About</Link>
              </div>
              <div
                className={`p-2 lg:-4 border-b-2 border-black border-opacity-0 hover:border-opacity-100 hover:text-black duration-200 cursor-pointer ${
                  pathLocation === "/projects"
                    ? "text-gray-600"
                    : getInterface()
                      ? "text-black"
                      : "text-gray-300"
                }`}
              >
                <Link to="/projects">Projects</Link>
              </div>
              <div
                className={`p-2 lg:-4 border-b-2 border-black border-opacity-0 hover:border-opacity-100 hover:text-black duration-200 cursor-pointer`}
              >
                <Link
                  to="https://blog.nikolaarinanda.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Blog
                </Link>
              </div>
              <div
                className={`p-2 lg:-4 border-b-2 border-black border-opacity-0 hover:border-opacity-100 hover:text-black duration-200 cursor-pointer ${
                  pathLocation === "/contact"
                    ? "text-gray-600"
                    : getInterface()
                      ? "text-black"
                      : "text-gray-300"
                }`}
              >
                <Link to="/contact">Contact</Link>
              </div>

              {/* Desktop Light & Dark Mode */}
              <button className=" pl-3 pr-2 lg:pl-4" onClick={setInterface}>
                {getInterface() ? (
                  <img
                    src={`${process.env.PUBLIC_URL}/images/icon/dark-mode.png`}
                    alt="Dark Mode"
                    className="w-5 h-5"
                  ></img>
                ) : (
                  <img
                    src={`${process.env.PUBLIC_URL}/images/icon/light-mode.png`}
                    alt="Light Mode"
                    className="w-5 h-5"
                  ></img>
                )}
              </button>
            </nav>
          </div>

          {/* Mobile Menu */}
          <div class="md:hidden flex gap-4">
            {/* Mobile Light & Dark Mode */}
            <button className="pl-3 pr-2 lg:pl-4" onClick={setInterface}>
              {getInterface() ? (
                <img
                  src={`${process.env.PUBLIC_URL}/images/icon/dark-mode.png`}
                  alt="Dark Mode"
                  className="w-5 h-5"
                ></img>
              ) : (
                <img
                  src={`${process.env.PUBLIC_URL}/images/icon/light-mode.png`}
                  alt="Light Mode"
                  className="w-5 h-5"
                ></img>
              )}
            </button>

            {/* Hamburger Button */}
            <button
              className="flex flex-col gap-1"
              onClick={() => setIsHamburgerOpen(!isHamburgerOpen)}
            >
              <span
                className={`h-1 w-6 bg-gray-600 transition-all ${
                  isHamburgerOpen ? "rotate-45 translate-y-2" : ""
                }`}
              ></span>
              <span
                className={`h-1 w-6 bg-gray-600 transition-all ${
                  isHamburgerOpen ? "opacity-0" : ""
                }`}
              ></span>
              <span
                className={`h-1 w-6 bg-gray-600 transition-all ${
                  isHamburgerOpen ? "-rotate-45 -translate-y-2" : ""
                }`}
              ></span>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        <nav
          className={`nav md:hidden font-semibold flex flex-col items-center justify-end gap-2 overflow-hidden transition-all duration-300 ${
            isHamburgerOpen ? "max-h-40 py-4" : "max-h-0"
          }`}
        >
          <div
            className={` lg:-4 border-b-2 border-black border-opacity-0 hover:border-opacity-100 hover:text-black duration-200 cursor-pointer active ${
              pathLocation === "/about"
                ? "text-gray-600"
                : getInterface()
                  ? "text-black"
                  : "text-gray-300"
            }`}
          >
            <Link to="/about">About</Link>
          </div>
          <div
            className={`lg:-4 border-b-2 border-black border-opacity-0 hover:border-opacity-100 hover:text-black duration-200 cursor-pointer ${
              pathLocation === "/projects"
                ? "text-gray-600"
                : getInterface()
                  ? "text-black"
                  : "text-gray-300"
            }`}
          >
            <Link to="/projects">Projects</Link>
          </div>
          <div
            className={`lg:-4 border-b-2 border-black border-opacity-0 hover:border-opacity-100 hover:text-black duration-200 cursor-pointer`}
          >
            <Link
              to="https://blog.nikolaarinanda.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Blog
            </Link>
          </div>
          <div
            className={`lg:-4 border-b-2 border-black border-opacity-0 hover:border-opacity-100 hover:text-black duration-200 cursor-pointer ${
              pathLocation === "/contact"
                ? "text-gray-600"
                : getInterface()
                  ? "text-black"
                  : "text-gray-300"
            }`}
          >
            <Link to="/contact">Contact</Link>
          </div>
        </nav>
      </header>
    </div>
  );
};

export default Navbar;
